import { cn } from "../../../lib/utils";

type EmptyCellProps = { className?: string };
const EmptyCell: React.FC<EmptyCellProps> = ({ className }) => (
  <span className={cn("text-gray-400 text-left", className)}>-</span>
);

export { EmptyCell };
